import React, { Component } from 'react';
import {connect} from 'react-redux';
import { getAlloptionsByQuestion, updateQuestionDemographics, emptyDemographicsQuestions,softDeleteOption } from '../../actions/demographics';
import EditDemoQuestions from '../../components/demographics/editDemoQuestion';

class EditDemographicsQuestions extends Component {
  constructor(props){
    super(props)
    this.state={
       editQuestionData : '',
    };
    this.updateQuestionDemographics = this.updateQuestionDemographics.bind(this);
    this.emptyDemographicsQuestions = this.emptyDemographicsQuestions.bind(this);
    this.softDeleteOption = this.softDeleteOption.bind(this);
    this.gotoSubquestionView = this.gotoSubquestionView.bind(this);
  }

  componentDidMount(){
    
    if(this.props.location.state){
        const { editCategoryQuestionsItemData } = this.props.location.state;

        if(editCategoryQuestionsItemData){
        let catId = editCategoryQuestionsItemData.cat_id;
        let quesId = editCategoryQuestionsItemData.ques_id;
         this.props.dispatch(getAlloptionsByQuestion(quesId));
            this.setState({
                editQuestionData : editCategoryQuestionsItemData
            });
        }
    }else{
        this.props.history.push('/');
    }
  }

  updateQuestionDemographics(data){
    this.props.dispatch(updateQuestionDemographics(data))
  }

  emptyDemographicsQuestions(){
    this.props.dispatch(emptyDemographicsQuestions());
  }

  softDeleteOption(data){
    this.props.dispatch(softDeleteOption(data));
  }

  gotoSubquestionView( catId, quesId){
    this.props.history.push('/demoSubQuestion/&c:'+catId+'/&q:'+quesId);
  }
  
  render(){
    let showEditDemographicsQuestionView = "";
    if(this.state.editQuestionData){
        showEditDemographicsQuestionView = <EditDemoQuestions
        editQuestionData = {this.state.editQuestionData}
        demoGraphicsCatQuesOptionsListSuccess = {this.props.demoGraphicsCatQuesOptionsListSuccess}
        demoGraphicsCatQuesOptionsListData = {this.props.demoGraphicsCatQuesOptionsListData}
        updateQuestionDemographics = {this.updateQuestionDemographics}
        demoGraphicsQuestionUpdateSuccess = {this.props.demoGraphicsQuestionUpdateSuccess}
        demoGraphicsQuestionsUpdateSuccessMessage = {this.props.demoGraphicsQuestionsUpdateSuccessMessage}
        demoGraphicsQuestionsUpdateFailMessage = {this.props.demoGraphicsQuestionsUpdateFailMessage}
        emptyDemographicsQuestions = {this.emptyDemographicsQuestions}
        softDeleteOption = {this.softDeleteOption}
        gotoSubquestionView = {this.gotoSubquestionView}
        />
    }
    
      
    return (
        <div> 
             {showEditDemographicsQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsCatQuesOptionsListSuccess : state.demographics.demoGraphicsCatQuesOptionsListSuccess,
    demoGraphicsCatQuesOptionsListData : state.demographics.demoGraphicsCatQuesOptionsListData,
    demoGraphicsQuestionUpdateSuccess : state.demographics.demoGraphicsQuestionUpdateSuccess,
    demoGraphicsQuestionsUpdateSuccessMessage : state.demographics.demoGraphicsQuestionsUpdateSuccessMessage,
    demoGraphicsQuestionsUpdateFailMessage : state.demographics.demoGraphicsQuestionsUpdateFailMessage,
  }
}

export default connect(mapStateToProps)(EditDemographicsQuestions);



// WEBPACK FOOTER //
// ./src/pages/demographics/editDemoCatQuestion.js